export function toCamel(str : string) {
	return str.replace(/(\-[^-])/g, function($1) {
		return $1.toUpperCase().replace('-', '');
	});
}

export function capitalize(str : string) {
	// Capitalize the first letter
	return str.substr(0, 1).toUpperCase().concat(str.substr(1));
}



// WEBPACK FOOTER //
// typescript://../clientlibs/js/lib/vendor/terrific/utils/string.ts